import { Component, HostBinding, Input, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'app-loading-section',
  template: `
    <i [ngClass]="icon + ' ' + spinStyle"></i>
    <ng-content></ng-content>
  `,
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 0.5rem;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LoadingSectionComponent {
  @HostBinding('style.color')
  @Input()
  color = 'var(--info)'

  @HostBinding('style.font-size')
  @Input()
  size = '50px'

  @Input()
  icon = 'far fa-spinner'

  @Input()
  spinStyle = 'fa-spin'

  @HostBinding('style.padding')
  @Input()
  padding = '50px 0'
}
